<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="evgCombineCode"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="800"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ trigger: 'row', highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row }">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="!row.defaultImageUrl ? [] : [row.defaultImageUrl]"
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayName="{ row }">
        <span>{{ row.combineName }}</span>
        <br />
        <span>{{ row.combineNameEn }}</span>
      </template>

      <template v-slot:displayColor="{ row }">
        <span>{{ row.combineColor }}</span>
        <br />
        <span>{{ row.combineColorEn }}</span>
      </template>

      <template v-slot:displaySpec="{ row }">
        <div v-if="row.combinePattern">
          <span>{{ $l('table_cell_combinePattern') || '花型' }}：</span>
          <span>{{ row.combinePattern }}</span>
        </div>
        <div v-if="row.combineStyle">
          <span>{{ $l('table_cell_combineStyle') || '款式' }}：</span>
          <span>{{ row.combineStyle }}</span>
        </div>
        <div v-if="row.combineSize">
          <span>{{ $l('table_cell_combineSize') || '尺寸' }}：</span>
          <span>{{ row.combineSize }}</span>
        </div>
      </template>

      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    tableHeight: { type: Number, default: 800 },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('change', records.concat(reserves))
    },
  },
}
</script>
